// Migrated
<template>
  <div class="flex">
    <fa
      v-if="showIcon"
      class="mt-1 mr-2"
      icon="location-dot"
    />
    <span>
      <strong>
        {{ destination }}
      </strong>
      <template v-if="locationText">
        <span class="px-1">
          —
        </span>
        <span>
          {{ locationText }}
        </span>
      </template>
    </span>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    text: {
      type: String,
      default: null,
    },

    destination: {
      type: String,
      required: true,
    },

    postcode: {
      type: String,
      default: null,
    },

    locality: {
      type: String,
      default: null,
    },

    city: {
      type: String,
      default: null,
    },

    country: {
      type: String,
      default: null,
    },

    showIcon: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    locationText () {
      if (this.text) {
        return this.text
      }

      const parts = []

      if (this.postcode && this.locality) {
        parts.push(`${this.postcode} ${this.locality}`)
      } else if (this.locality) {
        parts.push(this.locality)
      }
      if (this.city) {
        parts.push(this.city)
      }
      if (this.country) {
        parts.push(this.country)
      }

      return parts.join(', ')
    },
  },
})
</script>
